module.exports = __webpack_public_path__ + "static/img/template.82e7c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/template.png
// module id = FeVF
// module chunks = 36